module.exports = __webpack_public_path__ + "graphics/button-bundle.ckh.79bdfce6477b4b44ed99355da89b589b.svg";